
import { Vue } from "vue-class-component";
import moment from "moment";
import {getEmployeeLogsRequest} from "@/services/EmplyeeService";

export default class Employee extends Vue {
	headline = "Benutzer Logs"
	logs: any = []
	moment = moment
	
	getLogs() {
		getEmployeeLogsRequest().then((res: any) => {
			if ( res.status == "OK" && res.result.length > 0 ) {
				this.logs = res.result
			}
		})
	}
	
	beforeMount() {
		this.getLogs()
	}
}
